export function initGoogleLib({gtmWebId = '', isEnableGaGtm = false}) {

	if (!gtmWebId || !isEnableGaGtm) return

	// Add script to the <head>
	const firstComment = document.createComment('Google Tag Manager')
	const secondComment = document.createComment('End Google Tag Manager ')
	const script = document.createElement('script')
	script.type = 'text/javascript'
	script.innerHTML = `
	    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	    })(window,document,'script','dataLayer','${gtmWebId}');`

	document.head.insertBefore(firstComment, document.head.firstChild)
	document.head.insertBefore(script, firstComment.nextSibling)
	document.head.insertBefore(secondComment, script.nextSibling)

	// Add noscript to the <body>
	document.body.insertAdjacentHTML(
		'afterbegin',
		`
			<!-- Google Tag Manager (noscript) -->
				<noscript>
					<iframe src='https://www.googletagmanager.com/ns.html?id=${gtmWebId}' height='0' width='0' style='display:none;visibility:hidden'></iframe>
				</noscript>
	    <!-- End Google Tag Manager (noscript) -->
		`,
	)
}

export const injectGAScripts = ({ gaWebId = '', isEnableGaGtm }) => {
	if (!gaWebId || !isEnableGaGtm) return
	const webIds = gaWebId.split(',')
	document.createComment('Google tag (gtag.js)')
	webIds.forEach((webId) => {
		const firstScript = document.createElement('script')
		firstScript.async = true
		firstScript.src = `https://www.googletagmanager.com/gtag/js?id=${webId}`
		document.head.appendChild(firstScript)

		const secondScript = document.createElement('script')
		secondScript.innerHTML = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', '${webId}');
		  `
		document.head.appendChild(secondScript)
	})
	document.createComment('End Google tag (gtag.js)')
}


// WEBPACK FOOTER //
// ./src/app/lib/GTM.js